import { getNativeContext } from '../helpers/get-native-context';
const DEFAULT_OPTIONS = {
    disableNormalization: false
};
export const createPeriodicWaveConstructor = (createNativePeriodicWave) => {
    return class PeriodicWave {
        constructor(context, options) {
            const nativeContext = getNativeContext(context);
            const mergedOptions = { ...DEFAULT_OPTIONS, ...options };
            // This does violate all good pratices but it is used here to simplify the handling of periodic waves.
            return createNativePeriodicWave(nativeContext, mergedOptions);
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/periodic-wave-constructor.js.map